module.exports = __webpack_public_path__ + "static/media/XL.e9da1975.jpg";